import { useMemo } from 'react';
import useSWR from 'swr';

import apiRequest from '@/services/apiRequest';
import { IMapboxPlacesResponse } from '@/services/types/mapbox/mapboxApi';

import { MAPBOX_BASE_URL, MAPBOX_TOKEN } from './useMapboxQuery';

type TCoordinatesProps = {
  lat?: number;
  lon?: number;
};

export const useReverseGeocoding = ({ lat, lon }: TCoordinatesProps) => {
  const url = useMemo(() => {
    if (!lat || !lon || isNaN(lat) || isNaN(lon)) return null;
    return `${MAPBOX_BASE_URL}/geocoding/v5/mapbox.places/${lon},${lat}.json`;
  }, [lat, lon]);

  const { data, error } = useSWR(
    url,
    async (reqUrl: string) => {
      try {
        return await apiRequest<IMapboxPlacesResponse>({
          url: reqUrl,
          params: { access_token: MAPBOX_TOKEN },
        });
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Reverse geocoding failed:', err);
        return null;
      }
    },
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    },
  );

  return {
    data,
    error,
    place: data?.features?.[0] ?? null,
  };
};
